/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Link_Web_ErrorInputs */

const en_dialog_link_web_error = /** @type {(inputs: Dialog_Link_Web_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There was an error while requesting conversion`)
};

const es_dialog_link_web_error = /** @type {(inputs: Dialog_Link_Web_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubo un error al solicitar la conversión`)
};

/**
* | output |
* | --- |
* | "There was an error while requesting conversion" |
*
* @param {Dialog_Link_Web_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_link_web_error = /** @type {((inputs?: Dialog_Link_Web_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Link_Web_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_link_web_error(inputs)
	return en_dialog_link_web_error(inputs)
});